import { ToastContainer } from "react-toastify";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  Outlet,
} from "react-router-dom";
import "./index.css";
import "@fontsource/poppins";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/400-italic.css";
import Sidebar from "./layout/sidebar";
import Navbar from "./layout/navbar";
import Login from "./pages/login";
import Services from "./pages/services";
import AboutUs from "./pages/about-us";
import ContactUs from "./pages/contact-us";
import Work from "./pages/work";
import Blog from "./pages/blog";
import Careers from "./pages/careers";
import Home from "./pages/home";
import Footer from "./pages/footer";
import AddWork from "./pages/add-work";
import AddBlog from "./pages/add-blog";
import NDADetails from "./pages/nda";
import Document from "./pages/document";
import AddCareer from "./pages/add-careers";
import AddTestimonial from "./pages/add-testimonial";
import Testimonial from "./pages/testimonials";
import ContactUsQuery from "./pages/contact-us-query";
import Applications from "./pages/applications";
import CaseStudies from "./pages/case-studies";
import AddCaseStudy from "./pages/add-case-study";
import AddService from "./pages/add-service";

import { ContextProvider, useStore } from "./utils/context";
import 'react-quill/dist/quill.snow.css';

function App() {
  return (
    <Router className="">
      <div className="App  ">
        <ContextProvider>
          <ToastContainer />
          <Routes>
            <Route path="/login" element={<NonAuthRoute />} />
            <Route path="/" element={<AuthLayout />}>
              <Route index element={<Navigate to="/home" replace />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/work" element={<Work />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/home" element={<Home />} />
              <Route path="/footer" element={<Footer />} />
              <Route path="/addwork/:id" element={<AddWork />} />
              <Route path="/add-blog" element={<AddBlog />} />
              <Route path="/nda" element={<NDADetails />} />
              <Route path="/document" element={<Document/>} />
              <Route path="/addcareer/:id" element={<AddCareer/>} />
              <Route path="/testimonials" element={<Testimonial/>} />
              <Route path="/testimonials/add" element={<AddTestimonial/>} />
              <Route path="/contactquery" element={<ContactUsQuery/>} />
              <Route path="/applications" element={<Applications/>} />
              <Route path="/case-studies" element={<CaseStudies />} />
              <Route path="/add-case-study" element={<AddCaseStudy />} />
              <Route path="/add-service/:id" element={<AddService />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ContextProvider>
      </div>
    </Router>
  );
}

const AuthLayout = () => {
  const { isAuthenticated } = useStore();
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="dashboard-layout overflow-x-hidden">
      <Sidebar />
      <div className="main-content">
        <Navbar />
        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

const NonAuthRoute = () => {
  const { isAuthenticated } = useStore();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }
  return <Login />;
};

export default App;
